import log from '../logger/log';
import marketTypeService from '../marketTypeService';
import server from '../server/server';
import storageService from '../storage/storageService';

async function setMockGigyaToken() {
    const isDCE2 = marketTypeService.isDCE2();

    if (!isDCE2) return;

    log.info(`gigyaMockService: start receive gigya token from mock service`);

    const response = await server.get(`http://127.0.0.1:5000/get`);

    storageService.setGamGigyaAccountDataFromStorage({gigyaJWT: response?.data});
}

export default {
    setMockGigyaToken,
};
